import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

import { companiesQueryKeys } from './queryKeys';

export const useCurrentTenantQuery = () => {
  const currentUserQuery = useCurrentUserQuery();

  return useQuery({
    queryKey: companiesQueryKeys.currentTenant(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.company, {
        params: { path: { id: currentUserQuery.data?.defaultTenantId ?? '' } },
      });
      return data;
    },
    enabled: Boolean(currentUserQuery.data?.defaultTenantId),
  });
};
